import { createContext, type Context } from 'react';

const contextName = 'SpaApdexAnalytics';
const spaApdexAnalyticsContext: Context<string> = createContext<string>(contextName);
export default spaApdexAnalyticsContext;
